import { useState, useEffect, React } from "react";
import { useDispatch, useSelector } from "react-redux";
import api from "../../utils/api";
// import { StarIcon } from "@material-ui/icons/Star";
import { useParams } from "react-router-dom";
import {
  Avatar,
  Box,
  Button,
  Card,
  CardContent,
  CardHeader,
  CardMedia,
  Grid,
  IconButton,
  Stack,
  Typography,
} from "@mui/material";
import { useNavigate } from "react-router-dom";
import CalendarMonthIcon from "@mui/icons-material/CalendarMonth";

import "react-responsive-carousel/lib/styles/carousel.min.css"; // requires a loader
import { Carousel } from "react-responsive-carousel";
import CallIcon from "@mui/icons-material/Call";
import HomeIcon from "@mui/icons-material/Home";
import CategoryIcon from "@mui/icons-material/Category";
import StarIcon from "@mui/icons-material/Star";
const ProjectDetails = () => {
  const [project, setProject] = useState({});
  const userstate = useSelector((state) => state.loginUserReducer);
  const { currentUser } = userstate;
  const params = useParams();

  useEffect(() => {
    api
      .get(`/projects/by-id/${params?.projectId}`)
      .then((res) => {
        console.log("project>", res.data);
        setProject(res.data);
      })
      .catch((err) => console.log(err));
  }, []);
  /********* */
  const [uploader, setUploader] = useState("");
  useEffect(() => {
    project?.userId &&
      api
        .get(`/user/getUserdataById/` + project?.userId)
        .then((res) => {
          // console.log("user", res?.data);
          setUploader(res?.data);
        })
        .catch((err) => console.log("err", err));
  }, [project]);
  /********* */

  const navigate = useNavigate();

  const deleteproject = (i) => {
    api
      .delete(`/projects/${i?._id}`)
      .then((res) => {
        if (res.data) {
          let notifBody = {
            userId: currentUser?.id,
            text: `Admin delete your projects for violating terms and conditions.`,
            forAll: false,
            receiverId: i?.userId,
          };
          api
            .post("/notifications", notifBody)
            .then((re) => console.log("notif", re.data));
          window.location.reload();
        }
      })
      .catch((err) => console.log);
  };
  return (
    <Box className="container">
      <Card sx={{ width: "100%", marginTop: "20px" }}>
        <CardHeader
          avatar={
            <Stack direction="column">
              {uploader?.profile ? (
                <Avatar src={uploader?.profile} />
              ) : (
                <Avatar sx={{ bgcolor: "colorThree.main" }} aria-label="recipe">
                  {uploader?.name?.at(0)?.toUpperCase()}
                </Avatar>
              )}
            </Stack>
          }
          // action={
          //   <IconButton aria-label="settings">
          //     <MoreVertIcon />
          //   </IconButton>
          // }
          title={uploader?.name?.toUpperCase()}
          subheader={new Date(project?.createdAt).toDateString()}
        />
        <CardContent>
          <Box>
            <Typography
              variant="h6"
              sx={{
                fontWeight: "600",
                width: "100px",
                color: "fontPrimaryColor.main",
              }}
            >
              {project?.title}
            </Typography>
          </Box>
          {project?.projectImage && (
            <Box sx={{ margin: "20px 0" }}>
              <img src={project?.projectImage} width="80%" height="auto" />
            </Box>
          )}

          <Box>
            <Grid container>
              <Grid item xs={12} sm={5}>
                <Box sx={{ display: "flex", gap: "15px" }}>
                  <Typography
                    variant="body2"
                    sx={{ fontWeight: "600", width: "100px" }}
                  >
                    Technology
                  </Typography>
                  <Typography variant="p">{project?.tech_used}</Typography>
                </Box>
                <Box sx={{ display: "flex", gap: "15px" }}>
                  <Typography
                    variant="body2"
                    sx={{ fontWeight: "600", width: "100px" }}
                  >
                    Price
                  </Typography>
                  <Typography variant="p">{project?.price}</Typography>
                </Box>
                <Box sx={{ display: "flex", gap: "15px" }}>
                  <Typography
                    variant="body2"
                    sx={{ fontWeight: "600", width: "100px" }}
                  >
                    Type
                  </Typography>
                  <Typography variant="p">{project?.projectType}</Typography>
                </Box>
              </Grid>
              <Grid item xs={12} sm={5}>
                <Box sx={{ display: "flex", gap: "15px" }}>
                  <Typography
                    variant="body2"
                    sx={{ fontWeight: "600", width: "100px" }}
                  >
                    Deadline
                  </Typography>
                  <Typography variant="p">{project?.deadline}</Typography>
                </Box>
                <Box sx={{ display: "flex", gap: "15px" }}>
                  <Typography
                    variant="body2"
                    sx={{ fontWeight: "600", width: "100px" }}
                  >
                    Payment By
                  </Typography>
                  <Typography variant="p">{project?.paymentBy}</Typography>
                </Box>
              </Grid>
            </Grid>

            <Box
              sx={{
                marginTop: "20px",
                display: "flex",
                gap: "10px",
                alignItems: "center",
              }}
            >
              <Typography
                variant="p"
                sx={{ fontWeight: "600", width: "100px" }}
              >
                Required Skills
              </Typography>
              <Box sx={{ display: "flex" }}>
                {project?.skills?.map((f) => (
                  <Typography
                    variant="body2"
                    sx={{
                      border: "1px solid lightgray",
                      width: "max-content",
                      padding: "2px 4px",
                      margin: "3px",
                      color: "colorThree.main",
                    }}
                  >
                    {f}
                  </Typography>
                ))}
              </Box>
            </Box>
            <Box
              sx={{
                marginTop: "30px",
                borderTop: "1px dashed lightgray",
                padding: "30px 0",
              }}
            >
              <Typography
                variant="body2"
                sx={{ fontWeight: "600", width: "100px" }}
              >
                Description
              </Typography>
              <Typography variant="body2">{project?.description}</Typography>
            </Box>
          </Box>
          <Box sx={{ display: "flex" }}>
            <Typography sx={{ flex: "0.3", fontWeight: "600" }}>
              Project Files
            </Typography>
            {project?.projectFileUrl ? (
              <Typography sx={{ flex: "0.3" }}>
                <a href={project?.projectFileUrl}>Click to download</a>
              </Typography>
            ) : (
              "N/A"
            )}
          </Box>

          {/* <a href={project?.generalData?.projectLocationLink} target="_blank">
        See Live Location
      </a> */}

          <Box sx={{ marginTop: "30px" }}>
            {currentUser?.isAdmin ? (
              <button
                className=" asc__submit__form__button"
                onClick={() => deleteproject(project)}
              >
                Delete project
              </button>
            ) : (
              <></>
            )}
          </Box>
        </CardContent>
      </Card>
    </Box>
  );
};

export default ProjectDetails;
